<template>
  <InfoLayout
    v-if="!isMobile"
    :current-path="reverseFull({ name: 'rate_fraud_free' })"
    :is-policy="false"
  >
    <template #title>
      {{ t('Отзывы без обмана', options) }}
    </template>
    <template #content>
      <RateFraudFreeContent />
    </template>
  </InfoLayout>
  <RateFraudFreeContent v-else />
</template>

<script lang="ts" setup>
import RateFraudFreeContent from 'src/components/pages/info/rate-fraud-free/index/RateFraudFreeContent/RateFraudFreeContent.vue'
import I18NextVue from 'i18next'
import { useContextStore, useURLStore } from 'src/store'
import type { ContextStore } from 'src/components/pages/info/legal-case-page/types'
import InfoLayout from 'src/layouts/info-pages/InfoLayout.vue'

const { t, language } = I18NextVue
const options = { ns: language }

const { reverseFull } = useURLStore()
const { context }: ContextStore = useContextStore()

const isMobile = context.flavour === 'mobile'
</script>
